import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LeadCaptureForm } from './LeadCaptureForm';
import { Check, Mail } from 'lucide-react';
export function PricingSection() {
  const [showLeadForm, setShowLeadForm] = useState(false);
  const navigate = useNavigate();
  const handleEnrollClick = () => {
    setShowLeadForm(true);
  };
  const handlePaymentSuccess = (reference: string) => {
    // Redirect to enrollment form page after successful payment
    navigate('/enrollment-form');
  };
  const handlePaymentClose = () => {
    console.log('Payment window closed');
  };
  return <div className="bg-white rounded-2xl shadow-xl border-2 border-blue-100 p-8 sticky top-24" data-id="element-449">
      <div className="mb-6" data-id="element-450">
        <div className="flex items-baseline gap-2 mb-2" data-id="element-451">
          <span className="text-4xl font-bold text-gray-900" data-id="element-452">₦150,000</span>
          <span className="text-gray-600" data-id="element-453">/ $100</span>
        </div>
        <p className="text-sm text-gray-600" data-id="element-454">
          One-time payment for full course access
        </p>
      </div>

      <div className="space-y-4 mb-8" data-id="element-455">
        <div className="flex items-start gap-3" data-id="element-456">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-457" />
          <span className="text-gray-700" data-id="element-458">8-week comprehensive program</span>
        </div>
        <div className="flex items-start gap-3" data-id="element-459">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-460" />
          <span className="text-gray-700" data-id="element-461">
            Live sessions with expert instructors
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-462">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-463" />
          <span className="text-gray-700" data-id="element-464">
            Lifetime access to course materials
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-465">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-466" />
          <span className="text-gray-700" data-id="element-467">
            Professional certificate upon completion
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-468">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-469" />
          <span className="text-gray-700" data-id="element-470">Portfolio templates and tools</span>
        </div>
        <div className="flex items-start gap-3" data-id="element-471">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-472" />
          <span className="text-gray-700" data-id="element-473">
            Career support and job placement assistance
          </span>
        </div>
      </div>

      {!showLeadForm ? <button onClick={handleEnrollClick} className="w-full bg-blue-600 text-white font-semibold py-4 px-6 rounded-full hover:bg-blue-700 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 transform" data-id="element-474">
          Enroll Now - Limited Slots
        </button> : <LeadCaptureForm course="Executive Assistant Mastery" amount={150000} payLabel="Pay ₦150,000" onPaymentSuccess={handlePaymentSuccess} onPaymentClose={handlePaymentClose} onCancel={() => setShowLeadForm(false)} data-id="element-475" />}

      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-476">
        <div className="bg-green-50 rounded-lg p-4 border border-green-200" data-id="element-477">
          <p className="text-sm text-green-900 font-medium mb-2" data-id="element-478">
            🎓 Special Group Rates Available
          </p>
          <p className="text-xs text-green-800 mb-3" data-id="element-479">
            Organizations, schools, or groups interested in bulk purchase can
            get tailored pricing.
          </p>
          <a href="mailto:support@myskillzhq.com" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700 font-medium transition-colors duration-200" data-id="element-480">
            <Mail className="w-4 h-4" data-id="element-481" />
            support@myskillzhq.com
          </a>
        </div>
      </div>
    </div>;
}